<div class="container">
  <app-generic-notification *ngIf="estado == 0"
    [titleNotification]="'Ejecución de Mantenimiento para'"
    [note]="'Si ya finalizo el mentenimiento cierre la orden de trabajo'"
    [closeButton]="true"    
    [commentButton]="true"
    (closeOrder)="close()"
    (addComment)="addComment($event)">
  </app-generic-notification> 
  
  <mat-card *ngIf="estado == 1" style="background-color: #ffffff7a;">
    <app-close-order
          (bodyOrder)="bodyOrden"
          [orderId]="orderId"
        ></app-close-order>    
  </mat-card>
</div>